// extracted by mini-css-extract-plugin
export var brand = "_4t-8";
export var compact = "_4t-5";
export var extraSmall = "_4t-6";
export var icon = "_4t-0";
export var large = "_4t-3";
export var light = "_4t-1";
export var medium = "_4t-4";
export var outline = "_4t-a";
export var primaryDark = "_4t-9";
export var primaryLight = "_4t-7";
export var primaryModern = "_4t-b";
export var success = "_4t-2";